import React from 'react';
import { Grid } from 'semantic-ui-react';

class Home extends React.Component {
  render() {
    return (
      <Grid className="overview">
        <Grid.Column textAlign="center" verticalAlign="middle">
          <Grid className="row">
            <Grid.Row centered>
              <div className="icon dev-and"></div>
              <h3>Channel SDKs</h3>
            </Grid.Row>
            <Grid.Row centered>
              <h4>Embed Zello in your apps and websites</h4>
            </Grid.Row>
            <Grid.Row centered>
              <span className="github-button"><a href="https://github.com/zelloptt/zello-channel-api/tree/master/sdks" target="_blank" rel="noopener noreferrer">View on Github</a></span>
            </Grid.Row>
          </Grid>
        </Grid.Column>
      </Grid>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Home.js